import { ReducerActionRotaSP } from 'store/modules/types';

import { ListaCepRequest, Types } from './types';

export function listaCepRequest(
	token: string,
	payload: ListaCepRequest,
): ReducerActionRotaSP {
	return {
		type: Types.LISTA_CEP,
		token,
		payload,
	};
}
export function listaCepSuccess(payload: []): ReducerActionRotaSP {
	return {
		type: Types.LISTA_CEP_SUCCESS,
		payload,
	};
}
export function listaCepFailure(payload: []): ReducerActionRotaSP {
	return {
		type: Types.LISTA_CEP_FAILURE,
		payload,
	};
}

export function listaCepClear(): { type: string } {
	return {
		type: Types.LISTA_CEP_CLEAR,
	};
}
